var KeyToText = require("warmup-questions-text.csv");
var KeywordToOptions = require("warmup-questions-options.csv");
var RelationVerbs = require("warmup-questions-relations.csv");

var WarmupQuestions = {
	getText: function(key, replacements = {}) {
		var match = _.findWhere(KeyToText, { key: key });
		if (!match) {
			return "MISSING VALUE";
		}
		var value = match.text;

		if (value.includes("{{")) {
			_.map(WarmupQuestions.KEYWORDS, (keyword) => {
				var toReplace = "{{" + keyword + "}}";

				// if this keyword is present to replace
				if (value.includes(toReplace)) {

					// first check the provided replacements hash for a value
					if (replacements[keyword]) {
						value = value.replace(new RegExp(toReplace, "g"), replacements[keyword]);

					// then check our own option lists for a value
					} else if (WarmupQuestions.getOptions(keyword)) {
						value = value.replace(new RegExp(toReplace, "g"), WarmupQuestions.getOptions(keyword));

					// handle the relational matrix differently
					} else if (keyword == WarmupQuestions.RELATIONAL_MATRIX) {
						var relationKey = replacements[WarmupQuestions.RELATION_KEY];
						value = value.replace(new RegExp(toReplace, "g"), WarmupQuestions.getRelationVerbOptions(relationKey));

					}
				}
			});
		}

		return value;
	},

	getOptions: function(keyword) {
		return KeywordToOptions[0][keyword];
	},

	getRelationVerbOptions: function(keyword) {
		return RelationVerbs[0][keyword];
	},

	getKey: function(question, stage, part, level) {
		return question + "." + stage + "." + part + ".level" + level;
	}
}

window.qq = WarmupQuestions;

// topic question replacement keywords
WarmupQuestions.TEXT_TYPE = "TEXT_TYPE";
WarmupQuestions.NF_SUBJECT_OPTIONS = "NF_SUBJECT_OPTIONS";

// fiction replacement keywords
WarmupQuestions.CHAR1_NAME = "CHAR1_NAME";
WarmupQuestions.CHAR2_NAME = "CHAR2_NAME";
WarmupQuestions.TRAIT_OPTIONS = "TRAIT_OPTIONS";
WarmupQuestions.GOAL_OPTIONS = "GOAL_OPTIONS";
WarmupQuestions.RELATION_OPTIONS = "RELATION_OPTIONS";
WarmupQuestions.DESCRIPTOR_OPTIONS = "DESCRIPTOR_OPTIONS";
WarmupQuestions.ORG_PIECE = "ORG_PIECE";
WarmupQuestions.ORG_PIECE_NUMBER = "ORG_PIECE_NUMBER";
WarmupQuestions.SELECTED_TEXT = "SELECTED_TEXT";
WarmupQuestions.SIMILAR_ELEMENT = "SIMILAR_ELEMENT";
WarmupQuestions.EMOTION_OPTIONS = "EMOTION_OPTIONS";
WarmupQuestions.ENTERED_WORD = "ENTERED_WORD";

// nonfiction replacement keywords
WarmupQuestions.ENTITY_TYPE = "ENTITY_TYPE";
WarmupQuestions.ENTITY1 = "ENTITY1";
WarmupQuestions.ENTITY2 = "ENTITY2";
WarmupQuestions.RELATIONAL_MATRIX = "RELATIONAL_MATRIX";
WarmupQuestions.HEADING_NUMBER = "HEADING_NUMBER";
WarmupQuestions.TEXT_FEATURE_OPTIONS = "TEXT_FEATURE_OPTIONS";
WarmupQuestions.FEATURE_TYPE = "FEATURE_TYPE";
WarmupQuestions.TOPIC = "TOPIC";
WarmupQuestions.HARD_WORD = "HARD_WORD";
WarmupQuestions.SPECIFIC_ENTITY = "SPECIFIC_ENTITY";

// not replacement keywords
WarmupQuestions.RELATION_KEY = "RELATION_KEY";

WarmupQuestions.KEYWORDS = [
	WarmupQuestions.TEXT_TYPE, WarmupQuestions.NF_SUBJECT_OPTIONS, WarmupQuestions.CHAR1_NAME,
	WarmupQuestions.CHAR2_NAME, WarmupQuestions.TRAIT_OPTIONS, WarmupQuestions.GOAL_OPTIONS,
	WarmupQuestions.RELATION_OPTIONS, WarmupQuestions.DESCRIPTOR_OPTIONS, WarmupQuestions.ORG_PIECE,
	WarmupQuestions.ORG_PIECE_NUMBER, WarmupQuestions.SELECTED_TEXT, WarmupQuestions.SIMILAR_ELEMENT,
	WarmupQuestions.EMOTION_OPTIONS, WarmupQuestions.ENTERED_WORD, WarmupQuestions.ENTITY_TYPE,
	WarmupQuestions.ENTITY1, WarmupQuestions.ENTITY2, WarmupQuestions.RELATIONAL_MATRIX,
	WarmupQuestions.HEADING_NUMBER, WarmupQuestions.TEXT_FEATURE_OPTIONS, WarmupQuestions.FEATURE_TYPE,
	WarmupQuestions.TOPIC, WarmupQuestions.HARD_WORD, WarmupQuestions.SPECIFIC_ENTITY
];

module.exports = WarmupQuestions;



// WEBPACK FOOTER //
// ./modules/lib/academic/WarmupQuestions.js